import services from "../axios/dbManag";

const token = localStorage.getItem("tokenAdb2c");

export const getSportpayResult = (data) =>
  data?.Result ?? data?.result ?? data ?? {};

export const getSportpayMessage = (data) => {
  const result = getSportpayResult(data);
  return (
    data?.Message ??
    data?.message ??
    data?.Error ??
    data?.error ??
    result?.Message ??
    result?.message ??
    result?.Error ??
    result?.error
  );
};

export const getSportpayStatusCode = (data, fallbackStatus) => {
  const result = getSportpayResult(data);
  const statusCode =
    data?.StatusCode ??
    data?.statusCode ??
    result?.StatusCode ??
    result?.statusCode ??
    fallbackStatus;
  return statusCode === undefined || statusCode === null
    ? statusCode
    : Number(statusCode);
};

export const isSportpayForbidden = (res) =>
  res?.status === 403 || getSportpayStatusCode(res?.data) === 403;

export const getSportpayStatement = (data) =>
  getSportpayResult(data)?.statements?.[0];

export const getSignedSportpayBalance = (balance) => {
  const amount = parseFloat(balance?.balanceAmount?.amount ?? 0) || 0;
  return {
    value: balance?.balanceSign === "D" ? -amount : amount,
    currency: balance?.balanceAmount?.currency || "EUR",
  };
};

export const getSaldoSportpay = () => {
  return services.sportpay
    .post("/v1/sportpay/conto/saldo", {
      token_verifica:
        sessionStorage.getItem("token_verifica") ||
        "C300A901BFFDE1C288BFFAB788DF3586DF9F3C67084D0B5721142EEEF1F4C385",
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const addPagamento = (pagamento) => {
  return services.dbManag
    .post("/economato/movimenti/pagamento/add", {
      ...pagamento,
      return_url: window.location.href,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const addMovimentoManuale = (movimento) => {
  return services.dbManag
    .post("/economato/societa/movimenti/manuali/add", {
      ...movimento,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const approvaMovimentiMultipla = (movimenti) => {
  return services.dbManag
    .post("/economato/movimenti/approvazione/multipla", {
      ...movimenti,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const approvaMovimentiMultiplaDaPagamento = (movimenti) => {
  return services.dbManag
    .post("/economato/movimenti/approvazione/multipla/da-pagamento", {
      ...movimenti,
      return_url: window.location.href,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const getMovimentiImporto = (movimenti) => {
  return services.dbManag
    .post("/economato/movimenti/totimporto/list", {
      movimenti: movimenti,
    })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return false;
    });
};

export const getRiepilogoEconomato = (id_societa, stagione) => {
  return services.dbManag
    .post("/economato/societa/movimenti_riepilogo/list", {
      id_societa: id_societa,
      stagione: stagione,
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      return e.response;
    });
};

export const getDettaglioPagamentoSportpay = (id_societa, id_movimento) => {
  return services.dbManag
    .post("/economato/societa/movimenti/pagamento/view", {
      id_societa: id_societa,
      id_movimento: id_movimento,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const spostaCrediti = (
  id_societa,
  anno_prov,
  anno_dest,
  importo,
  id_insegnante
) => {
  return services.dbManag
    .post("/economato/societa/sposta-crediti", {
      id_societa,
      anno_prov,
      anno_dest,
      importo,
      id_insegnante,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const stampaMovimentiSocieta = (
  id_societa,
  stagione,
  tipo_mov,
  causale_mov,
  descrizione,
  approvato,
  data_da,
  data_a,
  data_appr_da,
  data_appr_a,
  sortColumn,
  sortOrder
) => {
  const url = `${services.baseUrl}/economato/movimenti/stampa/get?id_societa=${id_societa}&stagione=${stagione}&tipo_mov=${tipo_mov}&causale_mov=${causale_mov}&descrizione=${descrizione}&approvato=${approvato}&data_da=${data_da}&data_a=${data_a}&data_appr_da=${data_appr_da}&data_appr_a=${data_appr_a}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&request=${token}`;
  const link = document.createElement("a");
  link.target = "_blank";
  link.href = url;
  link.setAttribute("download", `movimenti_economato_societa.pdf`);
  document.body.appendChild(link);
  setTimeout(() => {
    link.click();
    document.body.removeChild(link);
  }, 500);
};

export const stampaMovimentiEnte = (
  id_societa,
  stagione,
  tipo_mov,
  causale_mov,
  descrizione,
  approvato,
  data_da,
  data_a,
  data_appr_da,
  data_appr_a,
  sortColumn,
  sortOrder
) => {
  const url = `${services.baseUrl}/economato/movimenti/stampa/get?id_societa=${id_societa}&stagione=${stagione}&tipo_mov=${tipo_mov}&causale_mov=${causale_mov}&descrizione=${descrizione}&approvato=${approvato}&data_da=${data_da}&data_a=${data_a}&data_appr_da=${data_appr_da}&data_appr_a=${data_appr_a}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&request=${token}`;
  const link = document.createElement("a");
  link.target = "_blank";
  link.href = url;
  link.setAttribute("download", `movimenti_economato_ente.pdf`);
  document.body.appendChild(link);
  setTimeout(() => {
    link.click();
    document.body.removeChild(link);
  }, 500);
};

/* export const stampaMovimentiSocieta = (
  id_societa,
  stagione,
  tipo_mov,
  causale_mov,
  descrizione,
  approvato,
  data_da,
  data_a,
  data_appr_da,
  data_appr_a,
  sortColumn,
  sortOrder
) => {
  return services.downloadFile
    .get("/economato/movimenti/stampa/get", {
      params: {
        id_societa,
        stagione,
        tipo_mov,
        causale_mov,
        descrizione,
        approvato,
        data_da,
        data_a,
        data_appr_da,
        data_appr_a,
        sortColumn,
        sortOrder,
      },
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `movimenti_${id_societa}.pdf`);
      document.body.appendChild(link);
      link.click();
      return res;
    })
    .catch((e) => {
      return e.response;
    });
}; */

export const downloadRiconciliazioneMav = (
  id_riconciliazione,
  nomeFile = "riconciliazione_mav",
  estensione = "txt"
) => {
  return services.downloadFile
    .get("/economato/pagamenti/mav/documenti/riconciliazione/download", {
      params: { id_riconciliazione },
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nomeFile}.${estensione}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};

export const convertiMav = (id_persona, id_pagamento, descrizione) => {
  return services.dbManag
    .post("/economato/pagamenti/mav/converti", {
      id_persona,
      id_pagamento,
      descrizione,
    })
    .then((res) => {
      return res;
    })
    .catch((e) => {
      return e.response;
    });
};
